// extracted by mini-css-extract-plugin
export default {"checkmark_circle":"qwGe_","stroke":"xYtg1","checkmark":"uUKAS","fill":"IUHLo","scale":"MRBKD","checkmark_check":"JMmG4"};